import script from "./enroll.vue?vue&type=script&setup=true&lang=js"
export * from "./enroll.vue?vue&type=script&setup=true&lang=js"

import "./enroll.vue?vue&type=style&index=0&id=36e71564&lang=scss&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e71564"]])

export default __exports__